import { render, staticRenderFns } from "./ParentDatasetModal.vue?vue&type=template&id=7a83813c&scoped=true"
import script from "./ParentDatasetModal.vue?vue&type=script&lang=js"
export * from "./ParentDatasetModal.vue?vue&type=script&lang=js"
import style0 from "./ParentDatasetModal.vue?vue&type=style&index=0&id=7a83813c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a83813c",
  null
  
)

export default component.exports